import React, { Component } from "react";
import API from "../../apiService.js";
import ReactToPrint from "react-to-print";
import PrintButton from "../medical/PrintButton";
import moment from "moment";
import MedicalCertificatePrint from "../medicalCertificate/MedicalCertificatePrint";

export default class MedicalCertificateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      MedicalCertificate:
        this.props.MedicalCertificate.length > 0
          ? this.props.MedicalCertificate
          : [],
    };
  }
  // componentDidMount() {
  //   this.getMedicalCertificate();
  // }
  // getMedicalCertificate = async () => {
  //   const res = await API.get(
  //     "registration/medical_certificates/read/" + this.props.patient.id
  //   );
  //   if (res.code === 200) {
  //     this.setState({
  //       MedicalCertificate: res.data
  //     });
  //   }
  // };
  render() {
    console.log(this.props);
    let list = this.props.MedicalCertificate.map((data, key) => {
      if (key > 0) {
        return (
          <div
            className='alert alert-success  alert-dismissible fade show row'
            role='alert'
            key={key}>
            <span className='alert-icon'>
              <i className='bus-front-12' />
            </span>
            <span className='alert-text'>
              Tanggal Kunjungan : {moment(data.created_at).format("YYYY-MM-DD")}{" "}
              Keperluan : {data.explanation.name}
            </span>
            <div style={{ marginLeft: "1%" }}>
              {/* <ReactToPrint
                // copyStyles ={true}
                trigger={() => (
                  <a href="#">
                    <button className="btn btn-success">Cetak </button>
                  </a>
                )}
                content={() => this.componentRef}
              /> */}
              <PrintButton
                url={`/registration/medical_certificates/print/${data.id}`}
                buttonText='Cetak'
                color='secondary'
              />
              <div style={{ display: "none" }}>
                <MedicalCertificatePrint
                  ref={(el) => (this.componentRef = el)}
                  patient={this.props.patient}
                  medCertif={data}
                />{" "}
              </div>
            </div>
          </div>
        );
      }
    });
    return <div>{list}</div>;
  }
}
